import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "../../../PageLayout";
import { EStat } from "../../../libs/ui/src/Stat/EStat";
import useReport from "../../../hooks/useReport";
import { AppContext } from "../../../AppContext";
import { FaUserPlus } from "react-icons/fa";
import { PatientContext } from "../patientFromContext/PatientsContext";
import { EPageTitle } from "../../../libs/ui/src/Pagetitle/EPageTitle";
import { EButton } from "../../../libs/ui/src/Button/EButton";
import { EPatientList } from "../../../libs/ui/src/PatientList/EPatientList";
import useAnalytics from "../../../hooks/useAnalytics";
import EPendingVisitList from "../../Dashboard/components/EPendingVisitList";
import { BsDownload } from "react-icons/bs";

export default function PatientList() {

  const { role, user } = useContext(AppContext);

  const { setColorScheme } = useContext(PatientContext);

  const {
    handleDownloadAllReport
  } = useReport();


  const {
    totalStats,
  } = useAnalytics();

  const navigate = useNavigate();

  const [downloadId, setDownloadId] = useState<string | null>(null);

  useEffect(() => {
    setColorScheme({ head: "", body: "", text: "", footer: "" })
  }, []);


  return (
    <PageLayout
      header={
        <EPageTitle
          title="Patients"
          description="All patients registered with the centre"
          end={
            <>
              {/* <EStatsDownloadButton
                variant="primary"
                onBaselineDownload={() => {
                  handleDownloadBaseLineReport(role?.includes("Center") ? (user?.id ?? "") : undefined);
                }}
                onConsolidatedDownload={() => {
                  handleDownloadConsolidatedReport(role?.includes("Center") ? (user?.id ?? "") : undefined);
                }}
                onFollowupDownload={() => {
                  handleDownloadFollowUpReport(role?.includes("Center") ? (user?.id ?? "") : undefined);
                }}
              /> */}

              <EButton
                variant="primary"
                size="md"
                loading={downloadId === "main"}
                onClick={async () => {
                  setDownloadId("main");
                  const isCenter = role?.includes("Center");
                  const date = new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }).replace(/ /g, "-");
                  const fileName = isCenter
                    ? `${user?.first_name ?? "center"}-reports.xlsx`
                    : `admin-report-${date}.xlsx`;
                  await handleDownloadAllReport(fileName);
                  setDownloadId(null);
                }}
              >
                <BsDownload className="" /> Download
              </EButton>

              {role?.includes("Center") ?
                <EButton
                  className="btn-blue"
                  size="md"
                  onClick={() => {
                    navigate("/index/new-patient");
                  }}
                >
                  <FaUserPlus className="" /> Add New Patient
                </EButton>
                : <></>}
            </>
          }
        />
      }
    >
      <div>
        {/* Top Metric Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 h-20 mb-4">
          <EStat
            stat={totalStats?.symptomatic_gallstone_patients ?? 0}
            label="Symptomatic Gallstone"
            text="SGS"
            loading={downloadId === "symptomatic_gallstone"}
            onBaselineDownload={async () => {
              setDownloadId("symptomatic_gallstone");
              const prefix = role?.includes("Center") ? (user?.first_name ?? "center") : "admin";
              await handleDownloadAllReport(`${prefix}_symptomatic_gallstone.xlsx`, "symptomatic_gallstone");
              setDownloadId(null);
            }}
          />
          <EStat
            stat={totalStats?.asymptomatic_gallstone_patients ?? 0}
            label="Asymptomatic Gallstone"
            text="AGS"
            loading={downloadId === "asymptomatic_gallstone"}
            onBaselineDownload={async () => {
              setDownloadId("asymptomatic_gallstone");
              const prefix = role?.includes("Center") ? (user?.first_name ?? "center") : "admin";
              await handleDownloadAllReport(`${prefix}_asymptomatic_gallstone.xlsx`, "asymptomatic_gallstone");
              setDownloadId(null);
            }}
          />
          <EStat
            stat={totalStats?.gallbladder_cancer_patients ?? 0}
            label="Gallbladder Cancer"
            text="GBC"
            loading={downloadId === "gallbladder_cancer"}
            onBaselineDownload={async () => {
              setDownloadId("gallbladder_cancer");
              const prefix = role?.includes("Center") ? (user?.first_name ?? "center") : "admin";
              await handleDownloadAllReport(`${prefix}_gallbladder_cancer.xlsx`, "gallbladder_cancer");
              setDownloadId(null);
            }}
          />
          <EStat
            stat={totalStats?.non_gallstone_control_patients ?? 0}
            label="Non Gallstone Control"
            text="NGC"
            loading={downloadId === "non_gallstone_control"}
            onBaselineDownload={async () => {
              setDownloadId("non_gallstone_control");
              const prefix = role?.includes("Center") ? (user?.first_name ?? "center") : "admin";
              await handleDownloadAllReport(`${prefix}_non_gallstone_control.xlsx`, "non_gallstone_control");
              setDownloadId(null);
            }}
          />
          <EStat
            stat={totalStats?.total_patients ?? 0}
            label="Total Participants"
            text="Total"
            hideDownload
          />
        </div>
        <EPendingVisitList />

        <div className="max-w-[90vw]">
          <EPatientList
            onRowClick={(e: any) => navigate(`/index/patient/details?patient_id=${e?.user_id}`)}
            allowedFilters={{
              centerId: (true),
              disease_case: true,
              include: true,
            }}
          />
        </div>
      </div>
    </PageLayout>
  );
}
